"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
const math_1 = require("../../math");
const ShapeLoop_1 = require("../ShapeLoop");
/**
 *
 * @category Shapes.ShapeLoop
 * @class Circle
 * @extends {ShapeLoop}
 */
class Circle extends ShapeLoop_1.ShapeLoop {
    /**
     * Based on ShapeLoop, the number of point (resolution) is based on sideLength.
     *
     * @param {ShapeLoopSettings} [settings={}]
     * @memberof Circle
     */
    constructor(settings = {}) {
        settings.type = 'Circle';
        super(settings, true);
        this.loop = {
            start: 0,
            end: math_1.PI2,
            inc: propArguments => {
                const sideLength = this.getRepetitionSideLength(propArguments);
                return (1 / Math.pow(sideLength[0] * sideLength[1], 0.25)) * ShapeLoop_1.ShapeLoop.PId2;
            },
            vertex: shapeLoopRepetition => [Math.cos(shapeLoopRepetition.current), Math.sin(shapeLoopRepetition.current)],
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
}
exports.Circle = Circle;
//# sourceMappingURL=Circle.js.map